import DefaultModal from '@/components/Modals/DefaultModal'
import ConfirmCancelModalFooter from '@/components/Modals/ConfirmCancelModalFooter'
import { Flex } from '@/components/Flex'
import { Headline2, InfoLabel, Label } from '@/components/Typography'
import { useModal } from '@/hooks/useModal'
import { DefaultModalProp } from '@/typings/Modals'
import { useApplyClusterConfig } from '../application/hooks/useApplyClusterConfig'

/**
 * TEMPORARY (owner's word, 2026-08-10): this modal and its button exist to run
 * the one-off underlay→ul provider-network rename across the live fleet. After
 * the fleet migration the owner decides whether they stay.
 */
export default function ApplyClusterConfigModal({
  setOpen,
  ...props
}: DefaultModalProp) {
  const modal = useModal('applyClusterConfig')
  const { clusterId, clusterName } = modal.data

  const applyMutation = useApplyClusterConfig()

  const onConfirm = () => {
    applyMutation.mutate(clusterId, {
      onSuccess: () => modal.close(),
    })
  }

  return (
    <DefaultModal
      {...props}
      setOpen={setOpen}
      type="applyClusterConfig"
      modalHeader={<Headline2>Re-apply Cluster Config</Headline2>}
      modalBody={
        <Flex flexDirection="column" width="100%" mt="1rem" gap="0.75rem">
          <Label>
            Re-apply the config on {clusterName}? The cluster goes back into
            Setup in Progress and returns to Ready in a minute or two.
          </Label>
          <Label color="orange">
            Applying recreates the cluster&rsquo;s network objects on the live
            cluster. Everything riding the provider network — public VLAN
            networks, and DRBD replication where storage shares the port —
            briefly loses connectivity for a few seconds.
          </Label>
          <InfoLabel>
            Pick the moment: the blink hits running workloads, not just the
            control plane.
          </InfoLabel>
        </Flex>
      }
      modalFooter={ConfirmCancelModalFooter}
      isLoading={applyMutation.isPending}
      onConfirm={onConfirm}
      confirmButtonText="Re-apply Config"
      cancelButtonText="Cancel"
    />
  )
}
